<template>
  <v-row justify="center" class="dialog-information">
    <v-dialog
      content-class="dialog-location"
      v-model="dialogLocation"
      overlay-opacity="0.2"
      max-width="370"
      transition="dialog-bottom-transition"
      origin="center bottom"
      class="rounded-xl"
    >
      <v-card min-height="180" style="position: relative" class="rounded-xl">
        <template v-if="selectedMarker.status === 'donate-center'">
          <div class="mb-2 rounded-lg" height="200">
            <v-row no-gutters>
              <v-img
                :src="
                  selectedMarker.imageUrl
                    ? selectedMarker.imageUrl
                    : selectedMarker.icon
                "
                class="primary rounded-lg"
                height="200"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-row>
            <v-row no-gutters style="margin-top: -70px; margin-left: 20px">
              <v-img
                class="shrink d-flex rounded-lg align-center"
                style="background-color: transparent; z-index: 3"
                :src="selectedMarker.icon"
                width="90"
                height="90"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-row>
            <div
              class="text-h5 white--text mb-0"
              style="
                position: absolute;
                top: 100px;
                right: 0;
                left: 0;
                height:100px
                text-shadow: 0px 3px 10px #000;
                padding-left: 126px;
                padding-top: 64px;
                background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
              "
            >
              {{ $t(`dialogLocation.${selectedMarker.status}`) }}
            </div>
          </div>

          <v-row no-gutters>
            <v-col>
              <v-row no-gutters class="mx-6 mt-2 primary--text">
                <v-col cols="auto"
                  ><v-icon color="primary" left
                    >mdi-label-variant-outline</v-icon
                  ></v-col
                >
                <v-col
                  ><b>{{ selectedMarker.name }}</b></v-col
                >
              </v-row>
              <v-row
                no-gutters
                class="mx-6 primary--text"
                v-if="selectedMarker.description"
              >
                <v-col cols="auto"
                  ><v-icon color="primary" left>mdi-text</v-icon></v-col
                ><v-col>{{ selectedMarker.description }}</v-col>
              </v-row>
              <v-row no-gutters class="mx-6">
                <v-col cols="auto"
                  ><v-icon color="primary" left
                    >mdi-map-marker-outline</v-icon
                  ></v-col
                ><v-col>
                  <a
                    :href="selectedMarker.addressLink"
                    target="_blank"
                    class="primary--text"
                    style="text-decoration: none"
                    >{{ selectedMarker.address }}</a
                  ></v-col
                >
              </v-row>
              <v-row no-gutters class="mx-6">
                <v-col cols="auto"
                  ><v-icon color="primary" left
                    >mdi-phone-outline</v-icon
                  ></v-col
                ><v-col>
                  <a
                    :href="`tel:${selectedMarker.phone}`"
                    target="_blank"
                    class="primary--text"
                    style="text-decoration: none"
                    >{{ selectedMarker.phone }}</a
                  ></v-col
                >
              </v-row>
              <v-row no-gutters class="my-4 mx-6" justify="center">
                <v-btn
                  v-for="(social, index) in selectedMarker.socials"
                  :key="index"
                  class="text-none rounded-pill mr-2"
                  outlined
                  color="primary"
                  target="_blank"
                  :href="social.url"
                >
                  {{ social.name }}
                </v-btn></v-row
              >
            </v-col>
          </v-row>
        </template>

        <v-row no-gutters justify="center" class="pt-4" v-else>
          <div
            style="position: absolute"
            v-if="selectedMarker.status === 'cleaned'"
          >
            <v-img
              class="heart-1"
              src="/img/illustrations/heart.svg"
              width="30"
              height="30"
            ></v-img>
            <v-img
              class="heart-2"
              src="/img/illustrations/heart.svg"
              width="25"
              height="25"
            ></v-img>
          </div>

          <v-img
            :src="selectedMarker.icon"
            max-width="90"
            height="90"
            contain
          ></v-img>
          <div
            id="bigBox"
            v-if="
              selectedMarker.status === 'trash-1' ||
              selectedMarker.status === 'trash-2'
            "
          >
            <v-img
              id="box"
              class="fly-1"
              src="/img/illustrations/fly.svg"
              width="10"
              height="10"
            ></v-img>
            <v-img
              id="box2"
              class="fly-2"
              src="/img/illustrations/fly.svg"
              width="12"
              height="12"
            ></v-img>
          </div>
        </v-row>

        <template v-if="selectedMarker.status !== 'donate-center'">
          <v-row no-gutters justify="center">
            <v-card-title class="headline pa-0">
              {{ $t(`dialogLocation.${selectedMarker.status}`) }}
            </v-card-title></v-row
          >
          <v-row no-gutters justify="center" class="my-3">
            <v-col align-self="center"
              ><v-row no-gutters><Picture :before="true" /></v-row
              ><v-row
                v-if="selectedMarker.status === 'cleaned'"
                no-gutters
                justify="center"
                class="text-caption mt-1"
                >{{ $t(`dialogLocation.before`) }}</v-row
              ></v-col
            >
            <v-col
              v-if="selectedMarker.status === 'cleaned'"
              cols="auto"
              align-self="center"
              class="mb-6"
              ><v-icon>mdi-arrow-right</v-icon></v-col
            >
            <v-col
              v-if="selectedMarker.status === 'cleaned'"
              align-self="center"
              ><v-row no-gutters><Picture :after="true" /></v-row
              ><v-row no-gutters justify="center" class="text-caption mt-1">{{
                $t(`dialogLocation.after`)
              }}</v-row></v-col
            >
          </v-row>

          <v-row
            v-if="
              selectedMarker.status === 'trash-1' ||
              selectedMarker.status === 'trash-2'
            "
            no-gutters
            justify="center"
            class="mb-2"
          >
            <v-btn
              class="mx-6 mt-2 text-none rounded-pill"
              color="primary"
              x-large
              depressed
              @click="
                $store.dispatch('updateLocation', {
                  status: 'cleaned',
                  marker: selectedMarker,
                }),
                  $store.commit('setSelectedMarkerId', selectedMarker.id),
                  $store.commit('setDialogLocation', true)
              "
            >
              {{ $t("dialogLocation.justPickedUpTrash") }}
            </v-btn>
          </v-row>
          <v-row no-gutters justify="center">
            <div
              class="mx-6 text-caption mb-4 primary--text"
              v-if="
                selectedMarker &&
                selectedMarker.status !== 'donate-center' &&
                selectedMarker.createdAt
              "
            >
              {{
                selectedMarker.status === "cleaned"
                  ? $t("dialogLocation.cleanedAt")
                  : $t("dialogLocation.spottedAt")
              }}
              <b>
                {{
                  handleISOToRelativeTime(selectedMarker.createdAt.toDate())
                }}</b
              >
            </div></v-row
          >
        </template>

        <v-btn
          icon
          class="ma-2"
          style="position: absolute; top: 0; right: 0"
          @click="share"
          v-if="fromMobile && !iOS()"
          ><v-icon>mdi-share-variant-outline</v-icon></v-btn
        >
        <v-btn
          icon
          class="ma-2 transparent--text"
          :class="{
            'error--text':
              user.id === selectedMarker.userId && !selectedMarker.modified,
          }"
          style="position: absolute; top: 0; left: 0"
          @click="$emit('removeLocation', selectedMarker.id)"
          ><v-icon>mdi-delete-outline</v-icon></v-btn
        >
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ISOToRelativeTime } from "@/utils/dates.js";
import Picture from "@/components/Picture.vue";

import { mapState, mapGetters } from "vuex";

export default {
  components: {
    Picture,
  },
  computed: {
    fromMobile() {
      // console.log(navigator.userAgent);
      return navigator.userAgent.indexOf("Mobile") !== -1;
    },
    ...mapState(["user"]),
    ...mapGetters(["selectedMarker"]),
    dialogLocation: {
      get: function () {
        return this.$store.state.dialogLocation;
      },
      set: function (newValue) {
        this.$store.commit("setDialogLocation", newValue);
      },
    },
  },
  methods: {
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
    share() {
      this.$store.commit("setSnackbar", {
        color: "primary",
        timeout: 3000,
        text: this.$i18n.t("googleMapLoader.featureNotAvailable"),
      });
      // if (navigator.share && this.fromMobile) {
      //   navigator
      //     .share({
      //       url: `https://viral-kindness.web.app/location/${this.selectedMarker.position.lat()}&${this.selectedMarker.position.lng()}`,
      //     })
      //     .then(() => console.log("Share complete"));
      // }
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.dialog-location {
  position: fixed;
  bottom: 20px;
  margin: 0;
  border-radius: 20px !important;
}
.heart-1 {
  animation-name: heart1;
  animation-duration: 1s;
  position: relative;
  left: 66px;
  top: 20px;
  transform: rotateZ(25deg);
}
@keyframes heart1 {
  from {
    left: 0px;
    top: 40px;
    transform: rotateZ(0deg);
  }
  to {
    left: 66px;
    top: 20px;
    transform: rotateZ(25deg);
  }
}
.heart-2 {
  animation-name: heart2;
  animation-duration: 0.7s;
  position: relative;
  right: 66px;
  top: 20px;
  transform: rotateZ(-25deg);
}
@keyframes heart2 {
  from {
    right: 0px;
    top: 40px;
    transform: rotateZ(0deg);
  }
  to {
    right: 66px;
    top: 20px;
    transform: rotateZ(-25deg);
  }
}

#bigBox {
  position: absolute;
  width: 100px;
  /* border: solid 1px red; */
  height: 100px;
  top: 100px;
  left: calc(50% + 60px);
  margin: -100px 0 0 -120px;
  animation: bigBoxAnimation 5s linear infinite;
}
#box,
#box2 {
  /* border: solid 1px green; */
  position: absolute;
  top: 60%;
  left: 50%;
  width: 40px;
  height: 40px;
  margin: -20px 0 0 -20px;
  animation: boxAnimation 2.95s cubic-bezier(0.02, 0.01, 0.31, 1) infinite;
}
#box2 {
  /* border: solid 1px orange; */
  animation: boxAnimation 3.2s cubic-bezier(0.02, 0.01, 0.31, 1) infinite;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

@keyframes bigBoxAnimation {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes boxAnimation {
  50% {
    transform: translateY(50px);
  }
}
</style>
